export default (value: number, desiredUnit: string) => {
  const { locale } = useI18n()
  const numberFormat = new Intl.NumberFormat(locale.value, { maximumFractionDigits: 2 }).format
  const valueFloat = Number.parseFloat(value.toString().replace(',', '.'))

  switch (desiredUnit) {
    // \xa0 is a non-breaking space, so that the unit is not separated from the number when wrapping text
    // size
    case 'mm':
      return `${numberFormat(valueFloat)}\xA0mm`
    case 'cm':
      return `${numberFormat(valueFloat / 10)}\xA0cm`
    case 'm':
      return `${numberFormat(valueFloat / 1000)}\xA0m`
    // weight
    case 'mg':
      return `${numberFormat(valueFloat)}\xA0mg`
    case 'g':
      return `${numberFormat(valueFloat)}\xA0g`
    case 'kg':
      return `${numberFormat(valueFloat / 1000)}\xA0kg`
    // volume
    case 'mm³':
      return `${numberFormat(valueFloat)}\xA0mm³`
    case 'cm³':
      return `${numberFormat(valueFloat / 1000)}\xA0cm³`
    case 'm³':
      return `${numberFormat(valueFloat / 1000000)}\xA0m³`
    // default case
    default:
      return numberFormat(valueFloat)
  }
}
